#import "../../../fragments/UserFragment.graphql"

query GetUsersQuery($filter: UsersFilter) {
  users(first: 30, filter: $filter) {
    edges {
      node {
        id
        ... on User {
          ...UserFragment
          isOnline
          isBanned
          isPremium
        }
      }
    }
    totalCount
  }
}
